import { Component, OnInit,Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IonicSelectableComponent } from 'ionic-selectable'; //search en select
import * as firebase from 'firebase';
import { LoadingController ,AlertController} from '@ionic/angular';
import{ServiciodeAfesMultiplesService} from '../serviciode-afes-multiples.service'


//search en select
class Afe {
  public id: number;
  public name: string;
  public codigo: string;
  public proyecto: string;
  public afeNIT:string;
  public area:string;
  public codigoCompania:string;
}

@Component({
  selector: 'app-modal-afes-multiples',
  templateUrl: './modal-afes-multiples.page.html',
  styleUrls: ['./modal-afes-multiples.page.scss'],
})
export class ModalAfesMultiplesPage implements OnInit {
  @Input() regional

  afe;

    //contenidos de seleccion multiple
    arraydeafes = [];
    cursordeafes;

      //search select AFE
  listadeafes: Afe[];
  objetodeafe: Afe;
  suma=0;
  arraydeGerentesRegionales=[]
  esCentroDeCostos=false
  gerenteRegionalSeleccionado=''

  arraydeinputsAfe=[{afe:'',proyecto:'',porcentaje:'',area:'',codigoCompania:'',afeNIT:'',esCentroDeCostos:false,gerenteRegionalSeleccionado:'',isChecked:false}]

  borrainput(i){
    this.arraydeinputsAfe.splice(i,1);
  }


  seleccionaComoPrincipal(i){
   this.arraydeinputsAfe.forEach((item,index)=>{
     if(index != i){item.isChecked=false}
    //  if(index == i){item.isChecked=true}
   })
  }
  

  nuevoinput(){
    if(this.arraydeinputsAfe.length <= 5){
      this.arraydeinputsAfe.push({afe:'',proyecto:'',porcentaje:'',area:'',codigoCompania:'',afeNIT:'',esCentroDeCostos:false,gerenteRegionalSeleccionado:'',isChecked:false})
    }else{
      this.presentAlert("Límite de afes","Sólo es posible asignar máximo 5 afes")
    }
  }
  
  constructor(public alerta:AlertController,  public loadingController: LoadingController, public modalController: ModalController, public ServiciodeAfesMultiples:ServiciodeAfesMultiplesService) { }

  asignar(){

    this.verificaQueHayaUnSeleccionado((itemseleccionado)=>{
      this.suma=0;
      this.verificaporcentajes((suma)=>{
        if(suma != 100){
          this.presentAlert('Los porcentajes no suman el 100%','La suma de los porcentajes es superior o inferior a 100%. Verifica los valores e intenta de nuevo')
        }else
        if(suma == 100){
          this.ServiciodeAfesMultiples.arraydeafesmultiples = this.arraydeinputsAfe;
          this.ServiciodeAfesMultiples.itemseleccionado = itemseleccionado
          this.modalController.dismiss({
            'dismissed': true,
          });
        }
      })
    })
    
  }

  verificaQueHayaUnSeleccionado(callback){
    let chuleados=0
    let itemseleccionado=undefined
    this.arraydeinputsAfe.forEach((item,index)=>{
      if(item.isChecked==true){
        chuleados++;
        itemseleccionado = item
      }
      if(index == this.arraydeinputsAfe.length-1 && chuleados>0){
        callback(itemseleccionado)
      }else
      if(index == this.arraydeinputsAfe.length-1 && chuleados==0){
        this.presentAlert("No hay un item marcado para proyecto","Debe seleccionar un item para poder asignar un proyecto al pedido.")
      }
    })
  }



  ngOnInit() {
    this.cargaAfes()
  }


  //search select
  afeChange(event: {
    component: IonicSelectableComponent,
    value: any 
  },i) {
    // this.afe = event.value.codigo+" - "+event.value.proyecto;
    this.arraydeinputsAfe[i].afe = event.value.codigo;
    this.arraydeinputsAfe[i].proyecto = event.value.proyecto;
    this.arraydeinputsAfe[i].area =event.value.area;
    this.arraydeinputsAfe[i].codigoCompania = event.value.codigoCompania;
    this.arraydeinputsAfe[i].afeNIT = event.value.afeNIT;
    // if(event.value.codigo.length ==10){
    //   this.arraydeinputsAfe[i].esCentroDeCostos = true;
    //   this.presentAlert("Seleccione gerente regional","Debido a que el pedido está cargado a un centro de costos, este debe ser aprobado por un gerente regional. Seleccione un gerente regional antes de continuar")
    //   this.SeleccionaGerenteRegional()
    // }else{
    //   this.arraydeinputsAfe[i].esCentroDeCostos = false;
    //   this.arraydeinputsAfe[i].gerenteRegionalSeleccionado=''
    // }
  }


  SeleccionaGerenteRegional(){

    this.arraydeGerentesRegionales=[]
    firebase.firestore().collection("users").where("gerenteRegional","==",true).where("regionalGerenciada","==",this.regional).get().then((docs)=>{
      docs.forEach((item)=>{
        this.arraydeGerentesRegionales.push({nombre:item.data().nombre,email:item.data().email})
      })
    })

  }

  
  verificaporcentajes(callback){
    // let sumadeporcentajes = parseInt(this.arraydeinputsAfe[0].porcentaje) + parseInt(this.arraydeinputsAfe[1].porcentaje)  +  parseInt(this.arraydeinputsAfe[2].porcentaje)  + parseInt(this.arraydeinputsAfe[3].porcentaje) 
    this.arraydeinputsAfe.forEach((item,index)=>{
      this.suma = this.suma + parseInt(this.arraydeinputsAfe[index].porcentaje) 
      if(index==this.arraydeinputsAfe.length-1){
        callback(this.suma)
        console.log("Suma:"+this.suma)
      }
    })
  }


  cargaAfes(){

    this.presentLoading();
  
    this.arraydeafes = [];
    this.listadeafes = [];
    this.cursordeafes = 0;
     //QUERY DE AFES
     let querydeafes = firebase.firestore().collection("afes").where("activo","==",true);
     querydeafes.get().then((docs) => {
       docs.forEach((doc) => {
         this.arraydeafes.push(doc);
         this.listadeafes.push( { id:this.arraydeafes.length-1 , name: doc.data().codigoafe+" - "+doc.data().proyecto, codigo: doc.data().codigoafe, proyecto:doc.data().proyecto, area:doc.data().area, codigoCompania:doc.data().codigoCompania, afeNIT:doc.data().afeNIT  } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto
       });
       this.cursordeafes = this.arraydeafes[this.arraydeafes.length - 1];
  
       this.loadingController.dismiss()
     
     }).catch((err) => {
       console.log(err);
     });
  }


  async presentLoading() {
    const loading = await this.loadingController.create({
      message: 'Cargando items...',
      // duration: 6000
    });
    await loading.present();
  
    const { role, data } = await loading.onDidDismiss();
  
    console.log('Loading dismissed!');
  }


  async presentAlert(header, message) {
    const alert = await this.alerta.create({
      header: header,
      message: message,
      buttons: ['OK']
    });

    await alert.present();
  }


  



}

